import React from 'react';
import Icon from '../../../components/AppIcon';

const OnboardingPipelineCard = ({ stats }) => {
  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="bg-emerald-100 p-2 rounded-lg">
          <Icon name="TrendingUp" size={24} className="text-emerald-600" />
        </div>
        <h2 className="text-xl font-bold text-gray-900">Onboarding Pipeline</h2>
      </div>

      {/* Stats Grid */}
      <div className="space-y-4">
        <div className="bg-gradient-to-r from-emerald-50 to-emerald-100 rounded-lg p-4 border border-emerald-200">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm text-emerald-700 font-medium">Active Candidates</p>
            <Icon name="Users" size={20} className="text-emerald-600" />
          </div>
          <p className="text-3xl font-bold text-emerald-900">{stats?.activeCandidates || 0}</p>
        </div>

        <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg p-4 border border-blue-200">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm text-blue-700 font-medium">Average Completion</p>
            <Icon name="BarChart3" size={20} className="text-blue-600" />
          </div>
          <p className="text-3xl font-bold text-blue-900">{stats?.averageCompletion || 0}%</p>
        </div>

        <div className="bg-gradient-to-r from-amber-50 to-amber-100 rounded-lg p-4 border border-amber-200">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm text-amber-700 font-medium">Overdue Tasks</p>
            <Icon name="AlertCircle" size={20} className="text-amber-600" />
          </div>
          <p className="text-3xl font-bold text-amber-900">{stats?.overdueTasksCount || 0}</p>
        </div>

        <div className="bg-gradient-to-r from-purple-50 to-purple-100 rounded-lg p-4 border border-purple-200">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm text-purple-700 font-medium">Documents Collected</p>
            <Icon name="FileCheck" size={20} className="text-purple-600" />
          </div>
          <p className="text-3xl font-bold text-purple-900">
            {stats?.documentsCollected || 0} / {stats?.documentsRequired || 0}
          </p>
        </div>
      </div>

      {/* Stage Distribution */}
      <div className="mt-6 pt-6 border-t border-gray-200">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">Stage Distribution</h3>
        <div className="space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-gray-600">Pre-Boarding</span>
            <span className="font-semibold text-gray-900">1</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-gray-600">First Day</span>
            <span className="font-semibold text-gray-900">1</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-gray-600">First Week</span>
            <span className="font-semibold text-gray-900">1</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-gray-600">90-Day Milestone</span>
            <span className="font-semibold text-gray-900">1</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingPipelineCard;